export default {
    map_geofence_geofencegroups: "Geocercas",
    map_geofence_manage_geofence: "Administrar Geocercas",
    map_geofence_manage_visible: "Gestionar Visibilidad",
    map_geofence_manage_showAll: "Mostrar Todos",
    map_geofence_manage_hiddenAll: "Ocultar Todos",
    map_geofence_geofenceList_invalid_geofence: "Esta geocerca tiene datos incompletos y no puede ser editada.",
};